var exports = {
  "R7": "xa15a2ab7--32ab69--agent_info",
  "YC": "xa15a2ab7--32ab69--titles",
  "my": "xa15a2ab7--32ab69--avatar",
  "yn": "xa15a2ab7--32ab69--avatar-img",
  "DD": "xa15a2ab7--32ab69--title",
};

module.exports = exports;
